import CloseIcon from 'admin/common/icons/CloseIcon';
import PrintIcon from 'admin/common/icons/PrintIcon';
import RightArrow from 'admin/common/icons/right-arrow';
import SearchIcon from 'admin/common/icons/SearchIcon';
import zonePdfIcon from '../../assets/images/zonePdfIcon.svg';
import zoneGridViewIcon from '../../assets/images/zonegridview.svg';
import zoneTableViewIcon from '../../assets/images/zonetablerview.svg';
import zoneSummaryIcon from '../../assets/images/zonesummaryicon.svg';
import zoneSummaryIconWhite from '../../assets/images/zonesummaryiconwhite.svg';
import TableLoader from 'admin/common/TableLoader';
import { DateRangeNew } from 'components/common/helpers/daterange';
import { Pagination } from 'components/common/Pagination';
import PlusIcon from 'Ecommerce/common/icons/PlusIcon';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import ZoneModal from './ZoneModal';
import ZoneIndexTableHead from './ZoneIndexTableHead';
import ZoneIndexGridView from './ZoneIndexGridView';
import ZoneIndexSummaryView, {
  ZoneIndexSummaryBulkAiButton,
  ZoneIndexSummaryCollapseToggle,
  ZoneIndexSummarySelectionBar,
} from './ZoneIndexSummaryView';
import ZoneIndexFilterPopup, {
  EMPTY_ZONE_INDEX_FILTERS,
} from './ZoneIndexFilterPopup';
import Apiauth from '../../API/Apiauth.js';
import {
  filterVaultListForZoneIndex,
  getLocationId,
  getLocationsWithZones,
} from './zoneIndexGridUtils';
import { error, loading, Updateloading } from 'components/common/helpers/toastify';
import './ZoneIndex.scss';

export default function ZoneIndex() {
  const { t } = useTranslation();
  const [limit, setLimit] = useState(100);
  const [VaultListData, setVaultListData] = useState([]);
  const [datefilter, setDatefilter] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [datalodaer, setDataLoader] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const [filtername, setFiltername] = useState('');
  const [filterCusomSearchSend, setSendFiltername] = useState('');
  const [gridSearchQuery, setGridSearchQuery] = useState('');
  const [selectAllStatus, setSelectAllStatus] = useState(false);
  const [selecteditem, setSelecteditem] = useState([]);
  const [viewMode, setViewMode] = useState('table');
  const [allZoneLocations, setAllZoneLocations] = useState([]);
  const [isSummaryActive, setIsSummaryActive] = useState(false);
  const [appliedTableFilters, setAppliedTableFilters] = useState(
    EMPTY_ZONE_INDEX_FILTERS
  );
  const [appliedGridFilters, setAppliedGridFilters] = useState(
    EMPTY_ZONE_INDEX_FILTERS
  );
  const [summaryAllExpanded, setSummaryAllExpanded] = useState(true);
  const [summaryCollapseResetKey, setSummaryCollapseResetKey] = useState(0);
  const [summaryBulkAiToolbar, setSummaryBulkAiToolbar] = useState(null);
  const [summarySelectionToolbar, setSummarySelectionToolbar] = useState(null);

  const [pages, setPages] = useState({ totalPages: 20, currentPage: 1 });
  const { totalPages, currentPage } = pages;

  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 },
  ];

  const getVaultList = useCallback(
    async (page = currentPage, firstLimit = limit) => {
      setDataLoader(true);

      try {
        const postdata = {
          search: filterCusomSearchSend,
          startDate: datefilter ? datefilter[0] : '',
          endDate: datefilter ? datefilter[1] : '',
          limit: firstLimit,
          skip: (page - 1) * firstLimit,
          locationIds: appliedTableFilters.locations,
          soldOut: appliedTableFilters.soldOut.includes('yes'),
        };
        const apiRes = await Apiauth(postdata, 'zone/vault-list');
        if (apiRes.code === 200) {
          setVaultListData(apiRes.data);
          setSelecteditem([]);
          setSelectAllStatus(false);
          setPages((prevPages) => ({
            ...prevPages,
            totalPages: Math.ceil(apiRes.total / postdata.limit),
          }));
        }
      } catch (err) {
        console.error(err, 'API Error');
      } finally {
        setDataLoader(false);
      }
    },
    [currentPage, limit, datefilter, filterCusomSearchSend, appliedTableFilters]
  );

  const loadZoneLocations = useCallback(async () => {
    try {
      const apiRes = await Apiauth({}, 'zone/all-zone');
      if (apiRes.code === 200) {
        setAllZoneLocations(apiRes.data?.locations || []);
      }
    } catch (err) {
      console.error(err, 'API Error');
    }
  }, []);

  const getAllZones = useCallback(async () => {
    setDataLoader(true);

    try {
      const apiRes = await Apiauth({}, 'zone/all-zone');
      if (apiRes.code === 200) {
        setAllZoneLocations(apiRes.data?.locations || []);
      }
    } catch (err) {
      console.error(err, 'API Error');
    } finally {
      setDataLoader(false);
    }
  }, []);

  useEffect(() => {
    loadZoneLocations();
  }, [loadZoneLocations]);

  useEffect(() => {
    if (viewMode === 'grid') {
      getAllZones();
    }
  }, [viewMode, getAllZones]);

  useEffect(() => {
    if (viewMode === 'table' && datefilter[0] && datefilter[1]) {
      getVaultList(currentPage, limit);
    }
  }, [getVaultList, currentPage, limit, datefilter, viewMode]);

  const filterLocationOptions = useMemo(
    () =>
      getLocationsWithZones(allZoneLocations).map((location) => ({
        id: getLocationId(location),
        name: location?.name || '-',
      })),
    [allZoneLocations]
  );

  const filteredVaultListData = useMemo(
    () =>
      filterVaultListForZoneIndex(
        VaultListData,
        appliedTableFilters,
        filterLocationOptions
      ),
    [VaultListData, appliedTableFilters, filterLocationOptions]
  );

  const handleTableFiltersApply = (nextFilters) => {
    setAppliedTableFilters(nextFilters);
    setPages((prevPages) => ({ ...prevPages, currentPage: 1 }));
  };

  const handleGridFiltersApply = (nextFilters) => {
    setAppliedGridFilters(nextFilters);
  };

  const activeAppliedFilters =
    viewMode === 'table' ? appliedTableFilters : appliedGridFilters;

  const handleActiveFiltersApply =
    viewMode === 'table' ? handleTableFiltersApply : handleGridFiltersApply;

  const handlePaginations = (newPage) => {
    setPages((prevPages) => ({
      ...prevPages,
      currentPage: newPage,
    }));
  };

  const handleChange = (event) => {
    if (event.target.checked) {
      setSelecteditem([...selecteditem, event.target.value]);
    } else {
      setSelecteditem(
        selecteditem.filter((element) => element !== event.target.value)
      );
    }
  };

  const CustomSearchFunction = (event) => {
    const searchInputValue = event?.target?.value;

    if (viewMode !== 'table') return;

    if (event.type === 'keydown' && event.key === 'Enter') {
      setSendFiltername(searchInputValue);
    }
  };

  const handleSearchChange = (event) => {
    const searchInputValue = event.target.value;
    setFiltername(searchInputValue);

    if (viewMode === 'grid') {
      setGridSearchQuery(searchInputValue);
    }
  };

  const handleCloseSearch = () => {
    setFiltername('');

    if (viewMode === 'grid') {
      setGridSearchQuery('');
    } else {
      setSendFiltername('');
    }

    setOpenSearch(false);
  };

  useEffect(() => {
    const allCheckbox = document.querySelectorAll('.zoneListCheckBox');
    if (selectAllStatus === true) {
      const selectedIds = [];
      allCheckbox.forEach((checkBoxSelectable) => {
        checkBoxSelectable.checked = true;
        const productId = checkBoxSelectable.getAttribute('data-id');
        if (productId) {
          selectedIds.push(productId);
        }
      });
      setSelecteditem(selectedIds);
    } else {
      allCheckbox.forEach((checkBoxSelectable) => {
        checkBoxSelectable.checked = false;
      });
      setSelecteditem([]);
    }
  }, [selectAllStatus]);

  const printButtonClick = async () => {
    if (selecteditem?.length > 0) {
      const GetloadingID = loading();
      try {
        const postdata = {
          ids: selecteditem,
          startDate: datefilter ? datefilter[0] : '',
          endDate: datefilter ? datefilter[1] : '',
        };
        const apiRes = await Apiauth(postdata, 'zone/print-vault-list');
        if (apiRes.code === 200) {
          setTimeout(() => {
            const exportLinkElement = document.createElement('a');
            exportLinkElement.hidden = true;
            exportLinkElement.download = apiRes?.name ? apiRes?.name : 'report.pdf';
            exportLinkElement.href = apiRes?.link;
            exportLinkElement.text = 'downloading...';
            exportLinkElement.setAttribute('target', '_blank');
            document.body.appendChild(exportLinkElement);
            exportLinkElement.click();
            exportLinkElement.remove();
            Updateloading(t, GetloadingID, t('Download successfully'));
          }, 50);
        }
      } catch (err) {
        console.error(err, 'API Error');
        error('There is a server-side error; please contact the server team..');
      }
    } else {
      error('Please select the record row for the Zone to print.');
    }
  };

  const downloadPdf = (link) => {
    if (!link) {
      console.error('No link provided for download.');
      return;
    }
    const anchorElement = document.createElement('a');
    anchorElement.style.display = 'none';
    anchorElement.href = link;
    anchorElement.download = '';
    anchorElement.target = '_blank';
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
  };

  const [currentKey, setCurrentKey] = useState(null);

  useEffect(() => {
    if (viewMode !== 'grid' || !isSummaryActive) {
      setSummaryBulkAiToolbar(null);
      setSummarySelectionToolbar(null);
    }
  }, [viewMode, isSummaryActive]);

  const toggleViewMode = () => {
    setViewMode((mode) => {
      const nextMode = mode === 'table' ? 'grid' : 'table';
      if (nextMode === 'table') {
        setIsSummaryActive(false);
        setFiltername(filterCusomSearchSend);
      } else {
        setFiltername(gridSearchQuery);
      }
      return nextMode;
    });
  };

  const handleSummaryCollapseToggle = () => {
    setSummaryAllExpanded((expanded) => !expanded);
    setSummaryCollapseResetKey((key) => key + 1);
  };

  useEffect(() => {
    if (viewMode === 'grid' && isSummaryActive) {
      setSummaryAllExpanded(true);
      setSummaryCollapseResetKey((key) => key + 1);
    }
  }, [viewMode, isSummaryActive]);

  const openStatusModal = (issueId) => {
    setOpenModal(true);
    setCurrentKey(issueId);
  };

  const handleStatusChange = async () => {
    try {
      const postdata = { id: currentKey, Status: 0 };
      const apiRes = await Apiauth(postdata, 'zone/edit-issue-stocks');
      if (apiRes.code === 200) {
        getVaultList(currentPage, limit);
      } else {
        console.error('Failed to update status');
      }
    } catch (statusError) {
      console.error('Error during API call:', statusError);
    } finally {
      setOpenModal(false);
      setCurrentKey(null);
    }
  };

  return (
    <div className="main-body zone_module zone-index">
      <div className="zone-index__page-header">
        <h1 className="main-body-heading">
          <span>
            <Link to="/app/inventory/myInventory" className="text-decoration-none">
              {t('Inventory')}
            </Link>
            <span className="ms-2">
              <RightArrow />
            </span>
          </span>
          {t('Zone')}
        </h1>
        <Link
          to="createissue"
          className="main-body-top-tab-bar-right-col-a"
          state={{ create: true }}
        >
          <PlusIcon color="#fff" />
          <span className="main-body-top-tab-bar-right-col-a-text">
            {t('Create Issue')}
          </span>
        </Link>
      </div>

      <div className="zone-index__content">
        <div className="zone-index__card">
        <div className="zone-index__toolbar">
          <div className="zone-index__toolbar-left">
            {viewMode === 'grid' &&
            isSummaryActive &&
            summarySelectionToolbar?.hasSelectedZones ? (
              <ZoneIndexSummarySelectionBar
                selectedCount={summarySelectionToolbar.selectedCount}
                isAllSelected={summarySelectionToolbar.isAllSelected}
                onSelectAllChange={summarySelectionToolbar.onSelectAllChange}
                onClear={summarySelectionToolbar.onClear}
                t={t}
              />
            ) : (
              <>
                <div className="zone-index__title-group">
                  <h2 className="zone-index__title">{t('All Zones')}</h2>
                  <button
                    type="button"
                    className="zone-index__icon-btn zone-index__view-toggle"
                    onClick={toggleViewMode}
                    aria-label={
                      viewMode === 'table' ? t('Grid view') : t('Table view')
                    }
                  >
                    {viewMode === 'table' ? (
                      <img src={zoneGridViewIcon} alt="" aria-hidden />
                    ) : (
                      <img src={zoneTableViewIcon} alt="" aria-hidden />
                    )}
                  </button>
                </div>
                {viewMode === 'grid' ? (
                  <button
                    type="button"
                    className={`zone-index__summary-btn${
                      isSummaryActive ? ' zone-index__summary-btn--active' : ''
                    }`}
                    aria-pressed={isSummaryActive}
                    onClick={() => setIsSummaryActive((active) => !active)}
                  >
                    <span className="zone-index__summary-btn-icon-wrap" aria-hidden>
                      <img
                        src={isSummaryActive ? zoneSummaryIconWhite : zoneSummaryIcon}
                        alt=""
                        className="zone-index__summary-btn-icon"
                      />
                    </span>
                    <span className="zone-index__summary-btn-label">{t('Summary')}</span>
                  </button>
                ) : null}
              </>
            )}
            {viewMode === 'table' ? (
            <Select
              className="zone-index__page-size select-set select p-0"
              options={selectOptions}
              value={{ label: limit, value: limit }}
              onChange={(option) => setLimit(option.value)}
              isSearchable={false}
              classNamePrefix="common-select"
            />
            ) : null}
          </div>

          <div className="zone-index__toolbar-right">
            <div className="zone-index__toolbar-actions">
              {viewMode === 'grid' && isSummaryActive ? (
                <ZoneIndexSummaryBulkAiButton
                  hasSelectedZones={summaryBulkAiToolbar?.hasSelectedZones ?? false}
                  isLoading={summaryBulkAiToolbar?.isLoading ?? false}
                  onClick={summaryBulkAiToolbar?.onClick}
                  t={t}
                />
              ) : null}
              {viewMode === 'grid' && isSummaryActive ? (
                <ZoneIndexSummaryCollapseToggle
                  isExpanded={summaryAllExpanded}
                  onToggle={handleSummaryCollapseToggle}
                  t={t}
                />
              ) : null}
              <ZoneIndexFilterPopup
                key={viewMode}
                locations={allZoneLocations}
                appliedFilters={activeAppliedFilters}
                onApply={handleActiveFiltersApply}
              />
              <div className="zone-index__search-wrap">
              {!openSearch ? (
                <button
                  type="button"
                  className="zone-index__icon-btn"
                  onClick={() => setOpenSearch(true)}
                  aria-label={t('Search')}
                >
                  <SearchIcon color="#A4A4A4" />
                </button>
              ) : null}
              <div
                className={`zone-index__search-bar${openSearch ? ' is-open' : ''}`}
              >
                <input
                  type="text"
                  value={filtername}
                  className="zone-index__search-input"
                  placeholder={t('Search')}
                  onChange={handleSearchChange}
                  onKeyDown={CustomSearchFunction}
                />
                <button
                  type="button"
                  className="zone-index__icon-btn"
                  onClick={handleCloseSearch}
                  aria-label={t('Close search')}
                >
                  <CloseIcon />
                </button>
              </div>
            </div>
            </div>
            <button
              type="button"
              className="zone-index__icon-btn"
              onClick={printButtonClick}
              aria-label={t('Print')}
              disabled={viewMode === 'grid'}
            >
              <PrintIcon color="#A4A4A4" />
            </button>
            {viewMode === 'table' ? (
              <DateRangeNew setDatefilter={setDatefilter} />
            ) : null}
          </div>
        </div>

        <div className="zone-index__table-section">
          <div
            className={`zone-index__table-wrap${
              viewMode === 'grid' ? ' zone-index__table-wrap--grid' : ''
            }${
              viewMode === 'grid' && isSummaryActive
                ? ' zone-index__table-wrap--summary'
                : ''
            }`}
          >
            {viewMode === 'table' ? (
            <table id="zoneindexTable" className="zone-index__table">
              <ZoneIndexTableHead
                selectAllStatus={selectAllStatus}
                setSelectAllStatus={setSelectAllStatus}
              />
              <tbody>
                {filteredVaultListData?.length ? (
                  filteredVaultListData.map((result) => (
                    <tr key={result?.id}>
                      <td className="zone-index__td--check">
                        <div className="com-check zone-index__check">
                          <input
                            className="inventorytablecheck inventorytableHead gisClassTh zoneListCheckBox"
                            id={result?.id}
                            data-id={result?.id}
                            value={result?.id}
                            type="checkbox"
                            onChange={handleChange}
                          />
                          <label htmlFor={result?.id} className="com-check-label" />
                        </div>
                      </td>
                      <td>
                        <Link
                          className="zone-index__ref-link"
                          to={`/app/inventory/zone/edit/${result?.id}`}
                        >
                          {result?.RefNo ? result.RefNo : '-'}
                        </Link>
                      </td>
                      <td>
                        <span className="zone-index__cell-text">
                          {result?.LocationId ? result.LocationId : '-'}
                        </span>
                      </td>
                      <td>
                        <span className="zone-index__cell-text">
                          {result?.ZoneId ? result.ZoneId : '-'}
                        </span>
                      </td>
                      <td className="zone-index__td--sale-person">
                        <span className="zone-index__cell-text">
                          {result?.SalePersonIds ? result.SalePersonIds : '-'}
                        </span>
                      </td>
                      <td className="zone-index__td--sku">
                        <span className="zone-index__cell-text">
                          {result?.SKUCount ? result.SKUCount : '-'}
                        </span>
                      </td>
                      <td>
                        <div className="zone-index__date-cell">
                          <span className="zone-index__date-primary">
                            {result?.IssueDate ? result.IssueDate : '-'}
                          </span>
                          {result?.IssueTime ? (
                            <span className="zone-index__date-secondary">
                              {result.IssueTime}
                            </span>
                          ) : null}
                        </div>
                      </td>
                      <td>
                        {result?.ReturnDate ? (
                          <div className="zone-index__date-cell">
                            <span className="zone-index__date-primary">
                              {result.ReturnDate}
                            </span>
                            {result?.ReturnTime ? (
                              <span className="zone-index__date-secondary">
                                {result.ReturnTime}
                              </span>
                            ) : null}
                          </div>
                        ) : (
                          '-'
                        )}
                      </td>
                      <td className="zone-index__td--metric">
                        {result?.issue ?? '-'}
                      </td>
                      <td className="zone-index__td--metric">
                        {result?.sold ?? '-'}
                      </td>
                      <td className="zone-index__td--metric">
                        {result?.return ?? '-'}
                      </td>
                      <td className="zone-index__td--metric">
                        {result?.balance ?? '-'}
                      </td>
                      <td className="zone-index__td--status">
                        <div
                          className={`zone-index__status ${
                            result?.Status === 1
                              ? 'zone-index__status--open'
                              : 'zone-index__status--close'
                          }`}
                          onClick={() => {
                            if (result?.Status === 1) {
                              openStatusModal(result?.id);
                            }
                          }}
                          onKeyDown={(event) => {
                            if (
                              result?.Status === 1 &&
                              (event.key === 'Enter' || event.key === ' ')
                            ) {
                              event.preventDefault();
                              openStatusModal(result?.id);
                            }
                          }}
                          role={result?.Status === 1 ? 'button' : undefined}
                          tabIndex={result?.Status === 1 ? 0 : undefined}
                        >
                          {result?.Status === 1 ? t('Open') : t('Close')}
                        </div>
                      </td>
                      <td className="zone-index__td--user">
                        <span className="zone-index__cell-text">
                          {result?.created_by ? result.created_by : '-'}
                        </span>
                      </td>
                      <td className="zone-index__td--action">
                        {result?.invoice ? (
                          <button
                            type="button"
                            className="zone-index__pdf-btn stockidSidebar tooltip-area-up"
                            onClick={() => downloadPdf(result.invoice)}
                            aria-label={t('Export Pdf')}
                          >
                            <img src={zonePdfIcon} alt="" aria-hidden />
                            <span className="tooltip-area-up-text whitenblack">
                              {t('Export Pdf')}
                            </span>
                          </button>
                        ) : (
                          '-'
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={15} className="zone-index__empty">
                      {t('No Data Available In Table')}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            ) : isSummaryActive ? (
              <ZoneIndexSummaryView
                locations={allZoneLocations}
                appliedFilters={appliedGridFilters}
                searchQuery={gridSearchQuery}
                allLocationsExpanded={summaryAllExpanded}
                collapseResetKey={summaryCollapseResetKey}
                onBulkAiToolbarChange={setSummaryBulkAiToolbar}
                onSelectionToolbarChange={setSummarySelectionToolbar}
                t={t}
              />
            ) : (
              <ZoneIndexGridView
                locations={allZoneLocations}
                appliedFilters={appliedGridFilters}
                searchQuery={gridSearchQuery}
                t={t}
              />
            )}

            {datalodaer ? (
              <div className="zone-index__table-loader">
                <TableLoader />
              </div>
            ) : null}
          </div>

          {viewMode === 'table' && filteredVaultListData.length > 0 ? (
            <div className="zone-index__pagination">
              <Pagination
                total={totalPages}
                current={currentPage}
                pagination={(crPage) => handlePaginations(crPage)}
              />
            </div>
          ) : null}
        </div>
        </div>
      </div>

      {openModal ? (
        <ZoneModal
          setOpenModal={setOpenModal}
          popupContent={{
            header: 'You Want to Change Status',
            subheader:
              'You want to change the status from open to close. The closed status cannot be changed.',
            withicon: false,
          }}
          onConfirm={handleStatusChange}
        />
      ) : null}
    </div>
  );
}
